<template>
  <div class="home">
    <Header />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Archievements from '@/components/Archievements.vue'
import Project from '@/components/Project.vue'

export default {
  name: 'HomeView',
  components: {
    Header,
    Archievements,
    Project
  }
}
</script>
